import { render, staticRenderFns } from "./footTips.vue?vue&type=template&id=21daec1e&scoped=true"
import script from "./footTips.vue?vue&type=script&lang=js"
export * from "./footTips.vue?vue&type=script&lang=js"
import style0 from "./footTips.vue?vue&type=style&index=0&id=21daec1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21daec1e",
  null
  
)

export default component.exports